// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"98":"5a327f5a","434":"72c1d706","455":"6dfea16b","731":"a34f84ab"}[chunkId] + ".chunk.js";
};